module.exports = __webpack_public_path__ + "img/button_anotovanie.b2b8e999.svg";